import React from 'react';

const ConfirmDialog = ({ isOpen, title, message, onConfirm, onCancel, confirmText = 'Confirm', cancelText = 'Cancel', confirmType = 'btn-error' }) => {
    if (!isOpen) return null;

    return (
        <dialog className="modal modal-open">
            <div className="modal-box">
                <h3 className="font-bold text-lg">{title}</h3>
                <p className="py-4">{message}</p>
                <div className="modal-action">
                    <button className="btn" onClick={onCancel}>
                        {cancelText}
                    </button>
                    <button className={`btn ${confirmType}`} onClick={onConfirm}>
                        {confirmText}
                    </button>
                </div>
            </div>
            <form method="dialog" className="modal-backdrop" onClick={onCancel}>
                <button>close</button>
            </form>
        </dialog>
    );
};

export default ConfirmDialog;
